<script setup lang="ts">
import { VDateInput } from 'vuetify/labs/VDateInput';
import Comment from "./Comments/CommentBox.vue";
import EmojiPicker from 'vue3-emoji-picker';
import 'vue3-emoji-picker/css';
import { formatTime } from './Home';
import { useHomeComponent } from './useHomeComponent';

const {
  authStore,
  tableHeaders,
  deals,
  totalDeals,
  loading,
  tooltiploading,
  dealCommentDialogFullScreen,
  collaboratorDialog,
  activeButton,
  showEmojiPicker,
  showGifPicker,
  selectedGifs,
  showSuggestions,
  caretPosition,
  isFilterPanelOpen,
  formattedDate,
  gifs,
  superAreas,
  segments,
  roles,
  selectedCollb,
  formatter,
  collaboratorArray,
  commentMessage,
  commentsArray,
  selectedcommentOrderId,
  isSubmittingCommention,
  filteredUsers,
  scrollContainer,
  commentSkentonloader,
  callBothApi,
  loadBonsuly,
  loadRealTimeLeaderboard,
  loadTooltipMessage,
  openCollaboratorDialog,
  openCommentModel,
  openEmojiModel,
  toggleGifPicker,
  toggleFilterPanel,
  closeCommentDialog,
  changeDate,
  setToday,
  filters,
  clearFilters,
  filterCount,
  handleMouseOver,
  handleLikeToggle,
  onSelectEmoji,
  addGif,
  removeGif,
  isUserLiked,
  selectUser,
  handleInput,
  addCollaborator,
  submitComment,
  handleAddReply,
} = useHomeComponent();
</script>


<template>
    <v-app>
      <v-app-bar>
        <template v-slot:prepend>
          <!-- Logo -->
          <img src="../assets/black-logo.svg" width="200" class="nav-logo" />
  
          <!-- "48 Deals" Blue Box -->
          <v-card class="blue-box" flat>
            <v-card-text class="text-center" style="font-weight: 700;">
              <div class="number">{{ totalDeals != null ? totalDeals.total_deals : '0'}}</div>
              <div class="label">Deals</div>
            </v-card-text>
          </v-card>
  
          <v-card class="blue-box" flat >
            <v-card-text class="text-center" style="font-weight: 700;">
              <div class="number"> {{ totalDeals != null ?  (formatter.format(parseFloat(totalDeals.total_deal_amount))).replace('$','') : '0' }}K</div>
              <div class="label">Total Sales</div>
            </v-card-text>
          </v-card>
        </template>
  
        <template v-slot:append>
          <v-list>
            <v-list-item :subtitle="authStore.userEmail" :title="authStore.userName" style="text-align: right;">
              <template v-slot:append>
                <v-menu>
                  <template v-slot:activator="{ props }">
                    <v-avatar color="secondary" v-bind="props" class="cursor-pointer">
                      {{ authStore.userName.charAt(0)}}
                    </v-avatar>
                  </template>
                  <v-list>
                    <v-list-item>
                      <v-list-item-title @click="authStore.logout">Logout</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </v-list-item>
          </v-list>
        </template>
      </v-app-bar>
  
      <v-main>
        <v-container fluid>
          <v-row>
            <v-col cols="12" md="12"> 
              <v-card class="full-width-card">
                <v-card-title>
                <div class="d-flex justify-space-between align-center">
                  <span>{{ formattedDate }}</span>
                  <span class="text-overline">
                    <div class="d-flex align-center">
                    <!-- Filter Button -->
                    <v-card class="icon-box" flat>
                    <v-card-text class="text-center" style="padding:2px">
                        <v-btn @click="toggleFilterPanel" :append-icon="isFilterPanelOpen ? 'mdi-chevron-up' : 'mdi-chevron-down'"
      prepend-icon="mdi-filter" color="secondary" class="filter-btn-with-badge">
                        Filter
                        <v-badge
                        v-if="filterCount > 0"
                        :content="filterCount"
                        color="red"
                        class="filter-badge" floating
                        
                    />
                        </v-btn>
                    </v-card-text>
                    </v-card>
                    
                    
                    
                    <v-card class="icon-box" flat>
                    <v-card-text class="text-center" style="padding:9px">
                        <v-icon class="cursor-pointer" @click="changeDate(-1)">mdi-chevron-left</v-icon>
                    </v-card-text>
                </v-card>
                   

                    <!-- Today Button -->
                    <v-card class="icon-box" flat>
                    <v-card-text class="text-center" style="padding:2px">
                        <v-btn variant="text" @click="setToday">Today</v-btn>
                    </v-card-text>
                </v-card>
                    

                    <!-- Right Arrow -->
                    <v-card class="icon-box" flat>
                    <v-card-text class="text-center" style="padding:9px">
                        <v-icon class="cursor-pointer" @click="changeDate(1)">mdi-chevron-right</v-icon>

                    </v-card-text>
                    </v-card>
                    </div>

                  </span>
                </div>
              </v-card-title>

              <v-card-title class="text-overline">
                <div class="text-green-darken-3 text-h3 font-weight-bold"></div>
                <div class="text-h6 text-medium-emphasis font-weight-regular">
                  
                </div>
              </v-card-title>
              </v-card>
            </v-col>
          </v-row>
          <v-row class="mb-4">
            <v-col>
                <!-- Filter Panel -->
    <v-slide-y-transition>
      <v-card v-if="isFilterPanelOpen" class="mt-3 p-4">
        
        <v-row>
            <v-col cols="12" md="12"> 
              <v-card class="full-width-card">
                <v-card-title>
                <div class="d-flex justify-space-between align-center">
                    <div class="d-flex align-center">
                    <!-- Filter Button -->
                    <v-card class="filterItembox" flat>
                    <v-card-text class="text-center" style="padding:10px">
                        <v-date-input v-model="filters.date"
                        label="Select a date"
                        prepend-icon=""
                        prepend-inner-icon="$calendar" 
                        variant="outlined" 
                    ></v-date-input>
                    </v-card-text>
                    </v-card> 
                    <v-card class="filterItembox" flat>
                    <v-card-text class="text-center" style="padding:10px">
                        <v-select
                        v-model="filters.superarea"
                        :items="superAreas"
                        label="Super Area" variant="outlined"
                        ></v-select>
                    </v-card-text>
                    </v-card>
                    <v-card class="filterItembox" flat>
                    <v-card-text class="text-center" style="padding:10px">
                        <v-select
                            v-model="filters.segment"
                            :items="segments"
                            label="Segment" variant="outlined"
                            ></v-select>
                    </v-card-text>
                    </v-card>
                    <v-card class="filterItembox" flat>
                    <v-card-text class="text-center" style="padding:10px">
                        <v-select
                        v-model="filters.role"
                        :items="roles"
                        label="Role" variant="outlined"
                        ></v-select>
                    </v-card-text>
                    </v-card>
                </div>
             </div>
                </v-card-title>
                </v-card>
            </v-col>
        </v-row>
        <v-row class="mb-4" style="text-align: left;">
                <v-col class="button-group">
                    <v-btn @click="callBothApi" color="secondary">Search</v-btn>
                    <v-btn @click="clearFilters"  flat>Clear Filters</v-btn>
                    
                </v-col>
            </v-row>
           
      </v-card>
    </v-slide-y-transition>
            </v-col>    
          </v-row>  
          
          <!-- Button Row -->
          <v-row class="mb-4" style="text-align: left;">
                <v-col class="button-group">
                    <v-btn @click="callBothApi" :class="{ 'active-button': activeButton === 'topDeals' }"  >Top Deals</v-btn>
                    <v-btn @click="loadBonsuly" :class="{ 'active-button': activeButton === 'bonusly' }"  >Bonusly</v-btn>
                    <v-btn @click="loadRealTimeLeaderboard" :class="{ 'active-button': activeButton === 'realTimeLeaderboard' }" >Real-Time Leaderboard</v-btn>
                </v-col>
            </v-row>
          
          
          <!-- Deals Table -->
          <v-data-table
                :headers="tableHeaders"
                :items="deals"
                class="elevation-1 header-center"
                :loading="loading"
            >
           
     
            <template #loading>
                    <v-skeleton-loader type="table-row@10"></v-skeleton-loader>
                </template>
                <template #item.sf_created_date="{ item }">
                    {{ formatTime(item.sf_created_date) }}
                </template>
                <template #item.sales_rep="{ item }">
                    <div style="display: flex; align-items: center;">
                        <v-avatar size="32" class="mr-2" color="secondary">
                          {{ item.sales_rep.charAt(0)}}
                          <!-- <v-img
                            alt="John"
                            src="https://cdn.vuetifyjs.com/images/john.jpg"
                        ></v-img> -->
                        </v-avatar>
                        <span>{{ item.sales_rep}}</span>
                    </div>
                </template>
                <template #item.sales_office="{ item }">
                    {{ item.sales_office }}
                </template>
                <template #item.product="{ item }">
                  <span v-html="item.product.replace(/,/g, '<br />')"></span>  
                  
                </template>
                <template #item.order_amount_usd="{ item }">
                  {{ (formatter.format(item.order_amount_usd)).replace('$','') }}  
                </template>
                <template #item.account_name="{ item }">
                    
                  {{ item.account_name }}
                </template>
                <template #item.subscription_period="{ item }">
                    {{ item.subscription_period }}
                </template>
                <template #item.competitor="{ item }">
                    {{ item.competitor }}
                </template>
                <template #item.industry="{ item }">
                    {{ item.industry }}
                </template>
                <template #item.days_closed_won="{ item }">
                    {{ item.days_closed_won }}
                </template>
                <template #item.collaborator="{ item }">
                  <button class="add-coll-button" @click="openCollaboratorDialog(item)" >
                    <!-- <i class="mdi mdi-plus icon" ></i> -->
                    <span class="text">View/Add</span>
                  </button>  
                  {{ item.collaborator }}
                </template>
                <template #item.likesComments="{ item }">
                    <v-tooltip bottom>
                      <template #activator="{ props }">
                        <v-icon v-bind="props"  class="like-icon" small
                        :color="isUserLiked(item) ? 'green' : 'gray'"
                        @mouseover="handleMouseOver"
                        @click = "handleLikeToggle(item)"
                        >
                          mdi-thumb-up 
                        </v-icon> ({{ item.like_count }})
                      </template>
                      <div class="custom-tooltip">
                        <template v-if="tooltiploading">
                          <v-progress-circular
                            indeterminate
                            color="#fffff"
                            size="24"
                            class="spinner"
                          ></v-progress-circular>
                        </template>
                        <template v-else>
                          <span>{{ loadTooltipMessage(item) }}</span>
                        </template>
                        <div class="arrow"></div>
                      </div>
                    </v-tooltip>
                  
                  
                  <!-- <v-icon class="like-icon" small color="secondary">
                    mdi-thumb-up {{ item.likesComments }}
                  </v-icon>  -->
                  <v-icon class="comment-icons" small color="secondary" @click="openCommentModel(item)">
                  mdi-comment
                </v-icon>
                </template>
                <template #item.badges="{ item }">
                    <div style="display: flex; align-items: center;">
                      <template v-if="item.subscription_period >= 24">
                      <img src="../assets/myd_icon.png" alt="">
                      </template>
                                                
                    </div>
                </template>
            </v-data-table>
          
          <!--Chip Dialog-->
          <v-dialog v-model="collaboratorDialog" max-width="900px" height="300px" class="comment-dialog">
            <v-card height="300px" class="comment-card" style="overflow: hidden">
              <v-card-title>
                Add collaborator 
              </v-card-title>
              <v-card-text>
               <!-- Combobox -->
               <v-combobox
                v-model="selectedCollb"
                :items="collaboratorArray"
                item-title="name"
                item-value="id"
                label=""
                                                
                multiple                
              >
                <!-- Chip Template -->
                <template v-slot:selection="{ attrs, item, parent, selected }">
                <v-chip v-bind="attrs" :input-value="selected" closable>
                  <span class="pr-2">
                    {{ item.title }}
                  </span>                  
                </v-chip>
              </template>
              </v-combobox>
              </v-card-text> 
              <v-card-actions>
                <v-spacer></v-spacer>
                    <v-btn variant="tonal"  
                    class="text-none submit-btn"
                    color="medium-emphasis"
                    min-width="92"
                    rounded  @click="addCollaborator(item)"
                    >Add Collaborator</v-btn> 
              </v-card-actions>   
            </v-card>  
          </v-dialog> 
          
          <!--Full Screen Dialog-->
          
            <v-dialog
              v-model="dealCommentDialogFullScreen"
              transition="dialog-bottom-transition"
              fullscreen
            >
              <v-card>
                <v-toolbar style="    background-color: rgb(var(--v-theme-secondary))">
                  <span style="font-size: 25px;
    font-weight: 600;
    padding: 20px;color:white">Comments ({{ commentsArray.length }})</span> 
                  <v-spacer></v-spacer>
                  <v-btn
                    icon="mdi-close"
                    @click="closeCommentDialog()"
                  ></v-btn>
                </v-toolbar>
                <v-row>
                  <v-col>
                    <!-- Skeleton Loader -->
                    <v-skeleton-loader
                                        v-if="commentSkentonloader"
                                        class="my-4"
                                        type="card"
                                        :loading="commentSkentonloader"
                                        elevation="0"
                                      >
                                        <template #default>
                                          <div v-for="i in 3" :key="i" class="mb-3">
                                            <v-skeleton-loader
                                              class="mb-2"
                                              :loading="commentSkentonloader"
                                              :type="['avatar', 'text', 'text']"
                                            />
                                          </div>
                                        </template>
                                      </v-skeleton-loader>
                                  
                    <v-card class="new_scrollable-comments" v-if="commentsArray.length" ref="scrollContainer" >
                      <Comment
                              v-for="comment in commentsArray"
                              :key="comment.id"
                              :comment="comment"
                              :level="0" 
                              @add-reply="handleAddReply"
                            />            
                      
                    </v-card>
                    <v-card class="new_scrollable-comments" v-if="commentsArray.length==0 && !commentSkentonloader">
                      <template v-slot:title>
                        <span class="font-weight-black ma-auto">Please be the first one to add a comment !!!</span>
                      </template>
                    </v-card>  
                  </v-col>
                </v-row>
                <!-- Fixed Bottom Comment Box -->
                    <v-footer absolute app class="new_comment-box" style="    background-color: rgb(var(--v-theme-secondary))">
                      <v-container>
                        <v-row justify="center">
                          <v-col cols="12">
                            <!-- Custom Text Box Using div -->
                            <div class="new_custom-textbox">
                              <div v-if="showSuggestions" class="show-suggestions-container">
                              <div
                              
                              :style="{ left: caretPosition.left + 'px' }"
                              class="mentions-dropdown"
                            >
                              <div
                                v-for="user in filteredUsers"
                                :key="user.id"
                                class="mention-item"
                                @click="selectUser(user)"
                              >
                              <div style="display: flex; align-items: center;">
                                  <v-avatar size="32" class="mr-2" color="secondary" rounded="0" style=" border-radius: 5px !important;">
                                    {{ user.name.charAt(0)}}
                                    <!-- <v-img
                                      alt="John"
                                      src="https://cdn.vuetifyjs.com/images/john.jpg"
                                  ></v-img> -->
                                  </v-avatar>
                                  <span>{{ user.name}}</span>
                              </div>
                              
                              <!-- <v-avatar size="30" rounded="0" style="margin-left:5px;">
                                <v-img src="https://cdn.vuetifyjs.com/images/john.jpg" style=" border-radius: 6px;"/>
                              </v-avatar> {{ user.name }} -->
                              </div>
                            </div>
                            </div>
                            <!-- Emoji Picker -->
                            <div v-if="showEmojiPicker" class="emoji-picker-containe">
                            <div  class="emoji-picker">
                              <EmojiPicker :native="true" @select="onSelectEmoji" />
                            </div>
                            </div>
                            <!-- GIF Picker -->
                            <div v-if="showGifPicker" class="gif-picker-container">
                            <div  class="gif-picker">
                              <div class="gif-picker-header">
                              <v-icon class="gif-icon">mdi-gif</v-icon>
                              <span class="gif-title">GIFs</span>
                            </div>
                              <div class="gif-grid">
                                <img
                                  v-for="gif in gifs"
                                  :key="gif"
                                  :src="gif"
                                  alt="GIF"
                                  class="gif-item"
                                  @click="addGif(gif)"
                                />
                              </div>
                            </div>
                            </div>
                              <textarea
                                v-model="commentMessage" @input="handleInput"
                                placeholder="Type your comment..."
                                class="new_comment-textarea"
                              ></textarea>
                              <!-- Display Selected GIFs -->
                              
                            </div>
                            <div class="selected-gifs" v-if="selectedGifs.length > 0">
                                <img
                                  v-for="gif in selectedGifs"
                                  :key="gif"
                                  :src="gif"
                                  alt="Selected GIF"
                                  class="gif-preview"
                                />
                                <v-btn
                                icon
                                @click="removeGif(index)"
                                class="remove-gif-button"
                                color="transparent" 
                              >
                                ✖
                              </v-btn>
                              </div>
                          </v-col>
                          <v-col cols="12" class="new_icons-row">
                            <v-btn icon class="mr-3" @click="toggleGifPicker">
                              <v-icon>mdi-sticker-emoji</v-icon>
                            </v-btn>
                            <v-btn icon class="mr-3"  @click="openEmojiModel">
                              <v-icon>mdi-emoticon-happy-outline</v-icon>
                            </v-btn>
                            <div style="float: right;">
                            <v-btn icon class="mr-3" @click ="submitComment(selectedcommentOrderId, commentMessage)" :disabled="commentMessage.trim().length == 0 && selectedGifs.length == 0" >
                             
                              <v-icon v-if="!isSubmittingCommention"  >mdi-send</v-icon>
                              <v-icon v-else>mdi-loading</v-icon>
                            </v-btn>
                            </div>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-footer>
              </v-card>
            </v-dialog>
 

          <!-- End of Dialog-->
        </v-container>
      </v-main>
    </v-app>
  </template>
  
 
<style scoped src="./HomeComponent.css"></style>

